/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { videoPlayerUiReducer } from "./videoPlayerUiSlice";
export { isPipEntryPending, setPipEntryPending } from "./videoPlayerUiThunks";
export {
  playbackStateUpdated,
  airingInfoUpdated,
  trickPlayStateUpdated,
  playableUpdated,
  actionKernelTypesUpdated,
  skipOccurred,
  setWasPiGEnteredFromMiniClick,
  exitToPreviousScreenRequested,
  exitToPreviousScreenHandled,
  standalonePlaybackStateUpdated,
  standalonePlaybackEndHandled,
  sessionStateUpdated,
  videoPlayerUiReset
} from "./videoPlayerUiSlice";
export type {
  VideoPlayerUiState,
  PlaybackStatePayload,
  AiringInfoPayload,
  TrickPlayStatePayload,
  AudioTrackUiOption,
  ActionKernelTypesPayload,
  MetadataStatePayload,
  SessionStatePayload
} from "./videoPlayerUi.types";
export {
  refreshPlaybackState,
  refreshActionKernelTypes,
  refreshTrickPlayState,
  subscribePlayerStateListener,
  unsubscribePlayerStateListener,
  cleanupPlayerStateListener,
  subscribeMetadataStateListener,
  unsubscribeMetadataStateListener,
  cleanupMetadataStateListener,
  subscribePlaybackErrorListener,
  unsubscribePlaybackErrorListener,
  subscribeStandalonePlaybackListener,
  unsubscribeStandalonePlaybackListener,
  startStandalonePlayback,
  stopStandalonePlayback,
  cleanupPlaybackErrorListener,
  exitPlaybackErrorOsd,
  subscribePlayableChangeListener,
  unsubscribePlayableChangeListener,
  cleanupPlayableChangeListener,
  subscribeExitToPreviousScreenListener,
  unsubscribeExitToPreviousScreenListener,
  cleanupExitToPreviousScreenListener,
  subscribePlaybackRestrictionListener,
  unsubscribePlaybackRestrictionListener,
  cleanupPlaybackRestrictionListener,
  subscribeSessionStateChangeListener,
  unsubscribeSessionStateChangeListener,
  cleanupSessionStateChangeListener,
  mountFullScreenPlayback,
  unmountFullScreenPlayback,
  skipForward,
  skipBackward,
  togglePlayPause,
  getPlayerVolume,
  setPlayerVolume,
  getPreviewChannelInfo,
  scrubComplete,
  switchToAtmospheric,
  exitFromPauseTimeout,
  enterBrowserFullscreenMode,
  exitBrowserFullscreenMode,
  goToLive,
  startOverOrRestart,
  getThumbnailForPosition,
  getThumbnailUrlTemplate,
  holdStart,
  trickPlayConfirm,
  holdRelease,
  trickPlayCancel,
  speedCycle,
  refreshAudioTracks,
  setAudioTrack,
  requestSingleRecording,
  requestSeriesRecording,
  initiateRecording,
  enterBrowserPictureInPictureMode,
  exitBrowserPictureInPictureMode,
  closeBrowserPictureInPictureMode,
  clearBrowserPictureInPictureMode,
  isBrowserPictureInPictureTransitionActive,
  isPictureInPictureSupported,
  getPlaybackVideoElement,
  getPictureInPictureLeaveResolveTimeoutMs,
  shouldReturnToPlayer,
  isReturnToPlayerIntended,
  setReturnToPlayerIntended,
  setNavigatingToPlayer,
  isPipToGuideConversionActive,
  setPipToGuideConversionActive,
  registerBeforeNavigateHandler,
  unregisterBeforeNavigateHandler,
  notifyBeforeNavigate,
  hidePlayback,
  isPlaybackHidden,
  hasPlayable
} from "./videoPlayerUiThunks";
export type { BeforeNavigateHandler } from "../../model/videoplayer/VideoPlaybackController";
export { MetadataState } from "../../model/videoplayer/enums";
export {
  selectCurrentTime,
  selectDuration,
  selectPlayerState,
  selectIsPlaying,
  selectIsBufferingStall,
  selectSeekRange,
  selectStartTimeLabel,
  selectEndTimeLabel,
  selectAiringStartEpoch,
  selectAiringEndEpoch,
  selectIsTrickPlayActive,
  selectTrickPlayMode,
  selectTargetPosition,
  selectIsBuffering,
  selectIsErrorRecovery,
  selectSeekPosition,
  selectPlayable,
  selectSeekDirection,
  selectSkipCounter,
  selectTrickPlayEligibility,
  selectTrickPlayRestrictionEnabled,
  selectIsTrickPlayInteractive,
  selectCurrentSpeedLevel,
  selectSpeedTriggeredByLongPress,
  selectSeekEntryPoint,
  selectSeekRangeMode,
  selectIsStartOverAvailable,
  selectAllowForward,
  selectAllowBackward,
  selectParentalControlsRating,
  selectProgramDetails,
  selectMetadataState,
  selectIsStartOverPlaying,
  selectIsCatchUpPlaying,
  selectIsSocuPlaying,
  selectIsNdvrPlaying,
  selectIsVodPlaying,
  selectIsPositionSettled,
  selectAudioTracks,
  selectSelectedAudioTrackId,
  selectAreMediaTracksReady,
  selectWasPiGEnteredFromMiniClick,
  selectActionKernelTypes,
  selectHasStartOverActionKernel,
  selectHasRecordActionKernel,
  selectHasModifyRecordingActionKernel,
  selectModifyRecordingCollectionId,
  selectIsPlayingTivoPlusChannel,
  selectShouldExitToPreviousScreen,
  selectSessionState
} from "./videoPlayerUi.selectors";
export { buildNowPlayingTileData } from "./nowPlayingTileMapper";
export type { NowPlayingTileMapperInput } from "./nowPlayingTileMapper";
